export const IS_PRODUCTION = process.env.NEXT_PUBLIC_ENVIRONMENT === 'PRD'
export const IS_DEVELOPMENT = !IS_PRODUCTION
